var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts"},[(_vm.loader)?_c('div',[_c('i',{staticClass:"el-icon-loading"})]):(_vm.datacollection.labels.length > 0)?_c('Chart',{style:(_vm.myStyles),attrs:{"chart-data":_vm.datacollection}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }